import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import { TextField } from 'redux-form-material-ui';
import { Field } from 'redux-form';
import { Row, Col } from 'react-flexbox-grid';
import {LoomisColors} from '../../lib/LoomisColors';
import { required } from '../../lib/validators';


const ResetPasswordForm = ({ handleSubmit}) => {

    const styles = {
        errorStyle: {
            color: LoomisColors.red,
        },
        underlineStyle: {
            borderColor: LoomisColors.darkerRed,
        },
        floatingLabelStyle: {
            color: LoomisColors.blueGrey,
        },
        floatingLabelFocusStyle: {
            color: LoomisColors.blueGrey,
        },
        textFieldStyle: {
            color: LoomisColors.white,
        },
    };

    return (
        <div className="FormWrapper">
            <div className="container">
                <Row>
                    <Col xs={12}>
                        <Row center="xs">
                            <Col xs={12} sm={6} md={4}>
                                <form className="ResetPassword" onSubmit={handleSubmit}>
                                    <div>
                                        <Field
                                            name="password1"
                                            validate={[required]}
                                            component={TextField}
                                            type="password"
                                            hintText="New Password"
                                            floatingLabelText="New Password"
                                            fullWidth={true}
                                            errorStyle={styles.errorStyle}
                                            underlineFocusStyle={styles.underlineStyle}
                                            floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                                            inputStyle={styles.textFieldStyle}
                                        />
                                    </div>
                                    <div>
                                        <Field
                                            name="password2"
                                            validate={[required]}
                                            component={TextField}
                                            type="password"
                                            hintText="Verify password"
                                            floatingLabelText="Verify password"
                                            fullWidth={true}
                                            errorStyle={styles.errorStyle}
                                            underlineFocusStyle={styles.underlineStyle}
                                            floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                                            inputStyle={styles.textFieldStyle}
                                        />
                                    </div>
                                    <div className="ButtonWrapper">
                                        <FlatButton
                                            type="submit"
                                            backgroundColor="#fff"
                                            label="Submit"
                                            fullWidth={true} />
                                    </div>
                                </form>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default ResetPasswordForm;


// WEBPACK FOOTER //
// ./src/components/resetPassword/ResetPasswordForm.js